import React, { FC } from 'react';

import { Box, UseDisclosureProps } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { ResourceExceptions } from 'containers/PolicyHub/Blueprints/Components/Blueprint/BlueprintPolicies/Policies/ResourceExceptions';

import { selectBlueprints } from '../../../../selectors';
import { actions } from '../../../../slice';

interface Props {
  columns: Record<string, any>[];
  resourceExceptions: UseDisclosureProps;
  getBlueprintPolicies();
}

export const PoliciesTable: FC<Props> = props => {
  const { columns, getBlueprintPolicies } = props;
  const dispatch = useDispatch();
  const { blueprintPolicies } = useSelector(selectBlueprints);

  useDeepCompareEffect(() => {
    getBlueprintPolicies();
  }, [getBlueprintPolicies]);

  return (
    <Box h="full" flex={1}>
      <Table
        data={blueprintPolicies.data}
        columns={columns}
        isLoading={blueprintPolicies.isLoading}
        cursor="pointer"
        pagination={{
          totalCount: blueprintPolicies.page.totalCount,
          pageInfo: blueprintPolicies.page.info,
          onChange: pageInfo => {
            dispatch(actions.updatePoliciesPagination(pageInfo));
          },
        }}
        //expanded={resourceExceptions.isOpen}
        styles={{ header: { zIndex: 800 } }}
        subComponent={({ row, expanded }) =>
          expanded && <ResourceExceptions row={row} isExpanded={expanded} />
        }
      />
    </Box>
  );
};
